
export interface IUcParamStr {
    uc_param_str?: string;
    dn?: string;
    ve?: string;
    bi?: string;
    fr?: string;
    mi?: string;
    nt?: string;
    cp?: string;
    wi?: string;
    ds?: string;
    ud?: string;
    sv?: string;
    nw?: string;
    pf?: string;
    la?: string;
    me?: string;
    ef?: string;
    ut?: string;
    ch?: string;
    lb?: string;
    gp?: string;
    wf?: string;
    nn?: string;
    pc?: string;
    td?: string;
    ai?: string;
}

export interface IIFlowParams {
    appname?: string;
    app?: string;
    set_lang?: string;
    ct_lang?: string;
    ver?: string;
    sver?: string;
    brow_ver?: string;
    brow_sver?: string;
    entry?: string;
    entry1?: string;
    entry2?: string;
    ucid?: string;
    uc_biz_str?: string;
    lang?: string;
}

export type ICommonParams = IUcParamStr & IIFlowParams;

export interface IParamBuilder<T> {
    getParams(queries: IUrlQueries): T;
    isTypeOf(params: {}): boolean;
    isKeyOf(key: string): boolean;
}

const UCPARAM_KEYS = ['uc_param_str', 'dn', 've', 'bi', 'fr', 'mi', 'nt', 'cp', 'wi', 'ds', 'ud',
    'sv', 'nw', 'pf', 'la', 'me', 'ef', 'ut', 'ch', 'lb', 'gp', 'wf', 'nn', 'pc', 'td', 'ai'];

const IFLOW_KEYS = [
    'appname', 'app', 'set_lang', 'ct_lang', 'ver',
    'sver', 'brow_ver', 'brow_sver', 'entry', 'entry1',
    'entry2', 'ucid', 'uc_biz_str', 'lang',
];

const SHARE_OUT_PRESERVE_KEYS = [
  'app', 'reco_id', 'channel_id',
];

interface IUrlQueries {
    [key: string]: any;
}

class ParamBuilder<T> implements IParamBuilder<T> {
    private keys: string[];
    constructor(keys: string[]) {
        this.keys = keys;
    }

    public getParams(queries: IUrlQueries, baseParams?: IUrlQueries): T {
       const allParams = Object.assign(baseParams || {}, queries);
       const params = {} as T;
       this.keys.forEach((key) => {
           params[key] = allParams[key];
       });
       if (!this.isTypeOf(params)) {
           throw new Error('params error');
       }

       return params;
    }

    public isTypeOf(params: {}): boolean {
        for (const key in params) {
            if (key && this.keys.indexOf(key) === -1) {
                return false;
            }
        }
        return true;
    }

    public isKeyOf(key: string): boolean {
        return key && this.keys.indexOf(key) !== -1;
    }

}

export const shareOutParamBuilder = new ParamBuilder<ICommonParams>(SHARE_OUT_PRESERVE_KEYS);
export const ucParamBuilder = new ParamBuilder<IUcParamStr>(UCPARAM_KEYS);
export const iflowParamBuilder = new ParamBuilder<IIFlowParams>(IFLOW_KEYS);
export const commonParamBuilder = new ParamBuilder<ICommonParams>(UCPARAM_KEYS.concat(IFLOW_KEYS));
